import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistVF.woff\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistMonoVF.woff\",\"variable\":\"--font-geist-mono\",\"weight\":\"100 900\"}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/app/components/contentparts/cookieconsent/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/app/components/navmenu/NavMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/app/footer/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/styles/NavMenu.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/styles/animate.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/styles/aos.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/styles/ChaletAwayDatePicker.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/styles/DestinationSearchArea.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/styles/home.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/styles/SearchBar.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/styles/style.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/styles/ChaletLoader.css");
